/**
 * Direct Purchase module.
 */
import iframe from '../../../components/iframe';
import dom from '../../../helpers/dom';
import modal from '../../../components/modal';

const directPurchase = () => {
  const purchaseButtonClass = 'js-direct-purchase';
  const purchaseButtonElements = [];
  const modalID = 'direct-purchase';
  const iframeClass = 'qusd-direct-purchase__iframe';
  let iframeInstance;

  const iframeResizerOptions = {
    log: false,
    autoResize: true,
    contentWindowBodyMargin: null,
    enablePublicMethods: false,
    interval: 32,
    scrolling: false,
    sizeHeight: true,
    sizeWidth: false,
    checkOrigin: false,
  };

  const isEventType = (e, type) => e
    && e.data
    && e.data.type
    && e.data.type === type;

  const extractDataFromPurchaseButton = (buttonElement) => ({
    url: buttonElement.getAttribute('data-url'),
    productId: buttonElement.getAttribute('data-id'),
    touchpoint: buttonElement.getAttribute('data-touchpoint'),
    experiment: buttonElement.getAttribute('data-exp'),
    coupon: buttonElement.getAttribute('data-coupon'),
    campaign: buttonElement.getAttribute('data-campaign'),
    locale: buttonElement.getAttribute('data-locale'),
    clientCountry: buttonElement.getAttribute('data-client-country'),
  });

  const generateDirectPurchaseUrl = (urlData) => {
    let queryString = `locale=${urlData.locale}`
      + `&cart=${urlData.productId}`
      + `&source_touchpoint=${urlData.touchpoint}`
      + `&campaign=${urlData.campaign}`
      + `&client_country=${urlData.clientCountry}`
      + '&flow=direct-purchase';

    if (urlData.experiment) {
      queryString += `&pg=${urlData.experiment}`;
    }

    if (urlData.coupon) {
      queryString += `&coupon=${urlData.coupon}`;
    }

    return urlData.url
      .replace(':query', queryString)
      .replace(':productId', urlData.productId);
  };

  const createIframeFromButtonData = (buttonElement) => {
    const directPurchaseData = extractDataFromPurchaseButton(buttonElement);
    const directPurchaseUrl = generateDirectPurchaseUrl(directPurchaseData);
    const iframeElement = document.createElement('iframe');
    iframeElement.setAttribute('src', directPurchaseUrl);
    iframeElement.setAttribute('class', iframeClass);
    return iframeElement;
  };

  const onClickPurchaseButton = (e) => {
    const buttonElement = e.target.tagName !== 'BUTTON'
      ? e.target.closest('button')
      : e.target;
    const iframeElement = createIframeFromButtonData(buttonElement);
    iframeInstance = iframe(iframeElement, iframeResizerOptions);
    modal.open(iframeElement, modalID);
  };

  const stopDirectPurchase = () => {
    iframeInstance.destroy();
    iframeInstance = null;
  };

  const onReceiveMessageFromIframe = (e) => {
    if (isEventType(e, 'PAR_LOGOUT')) {
      /*
       * To avoid inconsistencies,
       * it is necessary to close the modal containing the iframe when an automatic
       * logout occurs in the parent app.
       * This prevents the app from being navigable from the iframe.
       */
      modal.close();
    } else if (isEventType(e, 'PAR_NAVIGATION')) {
      /*
       * In the case of direct purchase,
       * it is necessary for the purchase links to open in the same window as the public site.
       * This is done to maintain the current behavior.
       */
      setTimeout(modal.close, 1000);
      window.location.href = e.data.payload.url;
    }
  };

  const addModalEventListeners = (e) => {
    if (e.detail.modalID === modalID) {
      window.addEventListener('message', onReceiveMessageFromIframe);
    }
    if (e.detail.modalID === modalID) {
      window.addEventListener('qustodio:modalClose', stopDirectPurchase);
    }
  };

  const removeModalEventListeners = (e) => {
    if (e.detail.modalID === modalID) {
      window.removeEventListener('message', onReceiveMessageFromIframe);
    }
    if (e.detail.modalID === modalID) {
      window.removeEventListener('qustodio:modalClose', stopDirectPurchase);
    }
  };

  const registerPurchaseButtons = (planboxElement) => {
    const buttonsInPlanbox = dom.getByClassName(purchaseButtonClass, planboxElement);
    if (buttonsInPlanbox !== null) {
      buttonsInPlanbox.forEach((button) => purchaseButtonElements.push(button));
    }
  };

  const init = () => {
    if (purchaseButtonElements.length > 0) {
      purchaseButtonElements.forEach((buttonElement) => {
        buttonElement.addEventListener('click', onClickPurchaseButton);
      });
    }
  };

  return {
    init,
    registerPurchaseButtons,
    stopDirectPurchase,
    addModalEventListeners,
    removeModalEventListeners,
  };
};

export default directPurchase();
